var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{attrs:{"size":"sm"},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('contact-travel-expert',{attrs:{"expert-data":_vm.expertData,"tour-name":_vm.tourName,"trip-id":_vm.tripId},on:{"done":function($event){_vm.visible = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }